import { Component, signal, computed, ChangeDetectionStrategy, inject, PLATFORM_ID, OnInit } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { FaqCategory } from '../../models/faq.model';
import { FAQ_DATA } from './faq-content';
import { MatCardModule } from '@angular/material/card';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../services/seo.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule, MatChipsModule, MatCardModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './faq.html',
  styleUrls: ['./faq.scss']
})
export class FaqComponent implements OnInit {
  private gtm = inject(GtmService);
  private seo = inject(SeoService);
  categories = signal<FaqCategory[]>(FAQ_DATA);
  platformId = inject(PLATFORM_ID);
  activeCategory = signal<string>('All');

  filteredData = computed(() => {
    const current = this.activeCategory();
    // 3. Read the signal using parenthesis: this.categories()
    if (current === 'All') {
      return this.categories();
    }
    return this.categories().filter(c => c.title === current);
  });
  
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;

      this.gtm.pageView({
        page_path: '/faq',
        page_title: 'FAQ | Horizinns'
      });

    }
    this.seo.updateMetaTags('FAQ', 'Frequently Asked Questions for Horizinns', undefined, `${environment.appUrl}/faq`);
    this.seo.addJsonLd({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Frequently Asked Questions",
      "description": "Frequently Asked Questions for Horizinns",
      "url": "${environment.appUrl}/faq"
    });
  }

  selectCategory(category: string) {
    this.activeCategory.set(category);
  }
}
